export default {
  // الترجمات الموجودة
  title: "المشاريع",
  createProject: "إنشاء مشروع",
  editProject: "تعديل مشروع",
  deleteProject: "حذف مشروع",
  projectDetails: "تفاصيل المشروع",
  projectName: "اسم المشروع",
  projectDescription: "وصف المشروع",
  projectStatus: "حالة المشروع",
  startDate: "تاريخ البدء",
  endDate: "تاريخ الانتهاء",
  progress: "التقدم",
  teamMembers: "أعضاء الفريق",
  tasks: "المهام",
  createdAt: "تاريخ الإنشاء",
  updatedAt: "تاريخ التحديث",
  status: {
    planning: "قيد التخطيط",
    inProgress: "قيد التنفيذ",
    onHold: "معلق",
    completed: "مكتمل",
    cancelled: "ملغى",
  },
  actions: {
    view: "عرض المشروع",
    edit: "تعديل المشروع",
    delete: "حذف المشروع",
    manage: "إدارة المشروع",
    addTask: "إضافة مهمة",
    addMember: "إضافة عضو",
  },
  logs: {
    title: "سجل المشروع",
    activity: "النشاط",
    changes: "التغييرات",
    noLogs: "لا توجد سجلات متاحة",
  },

  // من Project.vue
  addMember: "اضافة عضو",
  email: "البريد الالكتروني",
  emailExistsError:
    "هذا البريد الالكتروني مسجل بالفعل. يرجى استخدام بريد الكتروني اخر.",
  generalError: "حدث خطأ في التقديم. يرجى المحاولة مرة اخرى في وقت لاحق.",
  invalidCompanyIdOrUserId: "معرف الشركة غير صحيح.",
  projectDeleted: "تم حذف المشروع بنجاح.",
  projectAdded: "تم اضافة المشروع بنجاح.",
  deleteConfirmationTitle: "حذف المشروع",
  deleteConfirmationText: "هل تريد حذف هذا المشروع؟",
  delete: "حذف",
  addProject: "اضافة مشروع",
  description: "وصف المشروع",
  close: "اغلاق",
  create: "اضافة",
  projectsTable: "المشاريع",
  projectNameRequired: "يرجى ادخال اسم المشروع.",
  projectAddedError:
    "حدث خطأ في اضافة المشروع. يرجى المحاولة مرة اخرى في وقت لاحق.",
  from: "من",
  to: "إلى",
  projectManager: "مدير المشروع",
  assignManager: "تعيين المدير",
  enterDescription: "ادخال الوصف",
  enterProjectName: "ادخال اسم المشروع",
  saving: "يتم الحفظ...",
  noProjects: "لا يوجد مشاريع.",
  createee: "انشئ مشروعك من الزر المتواجد بالاعلي",
  departments: "الاقسام",
  selectDepartment: "اختر قسم",
  inactive: "غير نشط",
  active: "نشط",
  errorOccurred: "حدث خطأ",
  advancedSettings: "الإعدادات المتقدمة",
  searchEmployees: "ابحث عن الموظفين...",
  errorFetchingProjects: "خطأ في جلب المشاريع",

  // من ProjectsTable.vue
  // status: "حالة المشروع",
  projectCreatedBy: "منشئ المشروع",
  departmentName: "القسم",
  edit: "تعديل",
  deleteConfirmationSuccess: "تم حذف المشروع بنجاح.",
  update: "تحديث",
  projectUpdatedSuccessfully: "تم تحديث المشروع بنجاح",
  projectDeletedSuccessfully: "تم حذف المشروع بنجاح",
  deadline: "المهلة النهائية",
  log: "سجل",
  info: "معلومات",
  statusUpdatedSuccessfully: "تم تحديث الحالة بنجاح",
  noLogsAvailable: "لا يوجد سجلات متاحة",
  changedTheField: "قام بتغيير الحقل",
  onDate: "في تاريخ",
  noManager: "لا يوجد مدير",
  noDepartment: "لا يوجد قسم",
  openTaskDescription: "فتح وصف المهمة",
  searchManager: "ابحث عن المدير...",
  errorUpdatingStatus: "حدث خطأ في تحديث الحالة",
  errorUpdatingProject: "حدث خطأ في تحديث المشروع",
  errorDeletingProject: "حدث خطأ في حذف المشروع",
  loading: "جاري التحميل...",
};
